export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521870/AynaliTahir/aynal%C4%B1_kapakE_1.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521868/AynaliTahir/aynali002.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521869/AynaliTahir/aynali9.jpg'
];